<app-hint (close)="close()"></app-hint>